import React, { useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";

// Definindo o tipo Paciente
interface Profissional {
  profissional: string;
  quantidade: string;
  periodo: string;
}

interface Paciente {
  nome: string;
  regimeDeHome: string;
  coparticipacao: string;
  profissionais: Profissional[];
  materiaisFornecidos: string;
  empresa: string;
  cidade: string;
  dtinicio: string;
  dtfim: string;
}

const App: React.FC = () => {
  const [pacientes, setPacientes] = useState<Paciente[]>([
    {
      nome: "DJALMA MENDES DE ALMEIDA",
      regimeDeHome: "12 HORAS",
      coparticipacao: "DEMANDA JUDICIAL",
      profissionais: [
        { profissional: "Fisio", quantidade: "1", periodo: "semana" },
        { profissional: "Nutri", quantidade: "2", periodo: "Mês" },
      ],
      materiaisFornecidos: "X",
      empresa: "MILAGRES",
      cidade: "João Pessoa",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
    },
    {
      nome: "JOSEMAR NOBREGA GOES",
      regimeDeHome: "24 HORAS",
      coparticipacao: "DEMANDA JUDICIAL",
      profissionais: [
        { profissional: "Fisio", quantidade: "1", periodo: "semana" },
        { profissional: "Nutri", quantidade: "2", periodo: "Mês" },
      ],
      materiaisFornecidos: "X",
      empresa: "MILAGRES",
      cidade: "João Pessoa",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
    },
    {
      nome: "GEUZA DE MORAIS PINHEIRO",
      regimeDeHome: "12 HORAS",
      coparticipacao: "PLANO DE SAÚDE",
      profissionais: [
        { profissional: "Fisio", quantidade: "1", periodo: "semana" },
        { profissional: "Nutri", quantidade: "2", periodo: "Mês" },
      ],
      materiaisFornecidos: "Y",
      empresa: "SALVAÇÃO",
      cidade: "João Pessoa",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
    },
    {
      nome: "JOSÉ LUCAS DE ALMEIDA",
      regimeDeHome: "24 HORAS",
      coparticipacao: "DEMANDA JUDICIAL",
      profissionais: [
        { profissional: "Fisio", quantidade: "1", periodo: "semana" },
        { profissional: "Nutri", quantidade: "2", periodo: "Mês" },
      ],
      materiaisFornecidos: "Z",
      empresa: "SALVAÇÃO",
      cidade: "João Pessoa",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
    },
    {
      nome: "JOSE EDUARDO PINAUD MADRUGA",
      regimeDeHome: "12 HORAS",
      coparticipacao: "PLANO DE SAÚDE",
      profissionais: [
        { profissional: "Psico", quantidade: "1", periodo: "semana" },
        { profissional: "Nutri", quantidade: "2", periodo: "Mês" },
        { profissional: "Fono", quantidade: "5", periodo: "Mês" },
      ],
      materiaisFornecidos: "A",
      empresa: "MILAGRES",
      cidade: "João Pessoa",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
    },
    {
      nome: "CLEIDE GOMES GERMANO – AROEIRAS",
      regimeDeHome: "24 HORAS",
      coparticipacao: "PLANO DE SAÚDE",
      profissionais: [
        { profissional: "Fisio", quantidade: "1", periodo: "semana" },
        { profissional: "Curativo", quantidade: "1", periodo: "semana" },
      ],
      materiaisFornecidos: "B",
      empresa: "MILAGRES",
      cidade: "João Pessoa",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
    },
    {
      nome: "GERTRUDES DIAS SUPINO",
      regimeDeHome: "12 HORAS",
      coparticipacao: "DEMANDA JUDICIAL",
      profissionais: [
        { profissional: "Nutri", quantidade: "2", periodo: "Mês" },
      ],
      materiaisFornecidos: "C",
      empresa: "MILAGRES",
      cidade: "João Pessoa",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
    },
    {
      nome: "IVAN OLIMPIO – PATOS",
      regimeDeHome: "24 HORAS",
      coparticipacao: "PLANO DE SAÚDE",
      profissionais: [
        { profissional: "Fono", quantidade: "1", periodo: "semana" },
        { profissional: "Pscico", quantidade: "2", periodo: "Mês" },
      ],
      materiaisFornecidos: "D",
      empresa: "SALVAÇÃO",
      cidade: "João Pessoa",
      dtinicio: "01/12/2025",
      dtfim: "01/12/2025",
    },
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nome, setNome] = useState("");
  const [regimeDeHome, setRegimeDeHome] = useState("");
  const [coparticipacao, setCoparticipacao] = useState("");
  const [, setProfissionais] = useState<Profissional[]>([]); // Alterado para Profissional[]
  const [materiaisFornecidos, setMateriaisFornecidos] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [cidade, setCidade] = useState("");
  const [dtinicio, setDtinicio] = useState("");
  const [dtfim, setDtfim] = useState("");
  const cidades = [
    "João Pessoa",
    "Campina Grande",
    "Patos",
    "Cajazeiras",
    "Santa Rita",
    "Bayeux",
    "Sousa",
    "Cabedelo",
    "Pombal",
    "Areia",
    "Catolé do Rocha",
    "Aparecida",
    "Alagoa Grande",
    "Alagoa Nova",
    "Alagoinha",
    "Arara",
    "Araruna",
    "Areial",
    "Assunção",
    "Baía da Traição",
    "Baraúna",
    "Barra de São Miguel",
    "Barra de Santana",
    "Barra de Camaratuba",
    "Bayeux",
    "Boqueirão",
    "Borborema",
    "Brejo do Cruz",
    "Brejo dos Santos",
    "Cacimba de Areia",
    "Cacimbas",
    "Cajazeirinhas",
    "Camarão",
    "Campina Grande",
    "Capim",
    "Catingueira",
    "Conde",
    "Cuité",
    "Cuité de Mamanguape",
    "Curral de Cima",
    "Curral Velho",
    "Damião",
    "Desterro",
    "Diamante",
    "Emas",
    "Esperança",
    "Fagundes",
    "Frei Martinho",
    "Gado Bravo",
    "Guarabira",
    "Gurinhém",
    "Gurupá",
    "Ibiara",
    "Igaracy",
    "Imaculada",
    "Ingá",
    "Itabaiana",
    "Itaporanga",
    "Itatuba",
    "Jacaraú",
    "Jericó",
    "João Pessoa",
    "Joca Claudino",
    "Juarez Távora",
    "Juazeirinho",
    "Junco do Seridó",
    "Juripiranga",
    "Juru",
    "Lagoa",
    "Lagoa de Dentro",
    "Lagoa Seca",
    "Lastro",
    "Livramento",
    "Lucena",
    "Mãe D'Água",
    "Malta",
    "Mamanguape",
    "Manaíra",
    "Marcação",
    "Mari",
    "Marizópolis",
    "Massaranduba",
    "Mataraca",
    "Matinhas",
    "Mato Grosso",
    "Maturéia",
    "Mogeiro",
    "Montadas",
    "Monte Horebe",
    "Monteiro",
    "Mulungu",
    "Natuba",
    "Nazarezinho",
    "Nova Floresta",
    "Nova Olinda",
    "Nova Palmeira",
    "Olho d'Água",
    "Olivedos",
    "Ouro Velho",
    "Parari",
    "Passagem",
    "Patos",
    "Pau Ferro",
    "Pedra Lavrada",
    "Pedras de Fogo",
    "Piancó",
    "Picuí",
    "Pilar",
    "Pirpirituba",
    "Pocinhos",
    "Poço de José de Moura",
    "Pombal",
    "Prata",
    "Princesa Isabel",
    "Puxinanã",
    "Queimadas",
    "Remígio",
    "Riachão do Bacamarte",
    "Riachão",
    "Riacho de Santo Antônio",
    "Rio Tinto",
    "Salgado de São Félix",
    "Salgueiro",
    "Santa Cecília",
    "Santa Cruz",
    "Santa Luzia",
    "Santa Rita",
    "Santana de Mangueira",
    "Santana dos Garrotes",
    "Santo André",
    "São Bento",
    "São Domingos",
    "São Francisco",
    "São João do Cariri",
    "São João do Rio do Peixe",
    "São José da Lagoa Tapada",
    "São José de Caiana",
    "São José de Espinharas",
    "São José do Bonfim",
    "São José do Brejo do Cruz",
    "São José do Sabugi",
    "São José dos Cordeiros",
    "São Mamede",
    "São Miguel de Taipu",
    "São Sebastião de Lagoa de Roça",
    "São Vicente do Seridó",
    "Sapé",
    "Serra Branca",
    "Serra da Raiz",
    "Serra Grande",
    "Serraria",
    "Sertãozinho",
    "Sobrado",
    "Solânea",
    "Soledade",
    "Sossêgo",
    "Sousa",
    "Sumé",
    "Tacima",
    "Taperoá",
    "Tavares",
    "Teixeira",
    "Tenório",
    "Triunfo",
    "Uiraúna",
    "Umbuzeiro",
    "Várzea",
    "Vieirópolis",
    "Zabelê",
  ];

  const [profissionaisList, setProfissionaisList] = useState([
    { profissional: "", quantidade: "", periodo: "" },
  ]);

  const handleAddProfissional = () => {
    setProfissionaisList([
      ...profissionaisList,
      { profissional: "", quantidade: "", periodo: "" },
    ]);
  };

  // Função para atualizar os dados dos profissionais
  const handleChangeProfissional = (
    index: number,
    field: "profissional" | "quantidade" | "periodo", // Usando um union de tipos para garantir as chaves válidas
    value: string
  ) => {
    const updatedList = [...profissionaisList];
    updatedList[index][field] = value;
    setProfissionaisList(updatedList);
  };

  const handleRemoveProfissional = (index: number) => {
    setProfissionaisList((prevList) => prevList.filter((_, i) => i !== index));
  };

  const handleCidadeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCidade(e.target.value);
  };

  // Gerando um array com as letras de A a Z
  const letras = Array.from({ length: 26 }, (_, i) =>
    String.fromCharCode(65 + i)
  );

  const abrirModal = () => {
    setIsModalOpen(true);
  };

  const fecharModal = () => {
    setIsModalOpen(false);
    // Limpa o formulário quando o modal for fechado
    setNome("");
    setRegimeDeHome("");
    setCoparticipacao("");
    setProfissionais([]);
    setMateriaisFornecidos("");
    setEmpresa("");
    setCidade("");
    setDtinicio(""); // Limpa a data de início
    setDtfim(""); // Limpa a data de fim
  };

  const salvarPaciente = (e: React.FormEvent) => {
    e.preventDefault();
    const novoPaciente: Paciente = {
      nome,
      regimeDeHome,
      coparticipacao,
      profissionais: profissionaisList, // Agora estamos passando o array de profissionais
      materiaisFornecidos,
      empresa,
      cidade,
      dtinicio,
      dtfim,
    };
    setPacientes([...pacientes, novoPaciente]);
    fecharModal();
  };

  const editarPaciente = (paciente: Paciente) => {
    setNome(paciente.nome);
    setRegimeDeHome(paciente.regimeDeHome);
    setDtinicio(paciente.dtinicio);
    setDtfim(paciente.dtfim);
    setCoparticipacao(paciente.coparticipacao);
    setProfissionais(paciente.profissionais);
    setMateriaisFornecidos(paciente.materiaisFornecidos);
    setEmpresa(paciente.empresa);
    setCidade(paciente.cidade);
    abrirModal();
  };

  const excluirPaciente = (index: number) => {
    const novosPacientes = pacientes.filter((_, i) => i !== index);
    setPacientes(novosPacientes);
  };

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-4xl font-semibold text-gray-800 mb-6">
        Assistência Domiciliar - Home Care
      </h1>

      <div className="flex justify-between">
        {/* Botão para abrir o modal à esquerda */}
        <button
          onClick={abrirModal}
          className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-700 transition duration-300"
        >
          Adicionar Paciente
        </button>

        <Link to="/Home">
          <button className="bg-red-500 text-white px-6 py-2 rounded font-semibold hover:bg-red-600 transition">
            Voltar
          </button>
        </Link>
      </div>

      {/* Modal de Adicionar/Editar Paciente */}
      {isModalOpen && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-40">
          <div className="bg-white rounded-lg w-full max-w-4xl p-6 shadow-lg animate__animated animate__fadeIn overflow-y-auto max-h-[80vh]">
            <h2 className="text-2xl font-bold text-gray-700 mb-6">
              {nome ? "Editar Paciente" : "Adicionar Paciente"}
            </h2>
            <form onSubmit={salvarPaciente}>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-4">
                {/* Nome do Paciente */}
                <div className="col-span-1">
                  <label className="block text-lg font-medium text-gray-700 mb-2">
                    Nome do Paciente
                  </label>
                  <input
                    type="text"
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    placeholder="Nome do paciente"
                    className="w-full p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                {/* Regime de Home */}
                <div className="col-span-1">
                  <label className="block text-lg font-medium text-gray-700 mb-2">
                    Regime de Home
                  </label>
                  <select
                    value={regimeDeHome}
                    onChange={(e) => setRegimeDeHome(e.target.value)}
                    className="w-full p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  >
                    <option value="">Selecione o regime de home</option>
                    {[...Array(24)].map((_, index) => (
                      <option
                        key={index}
                        value={`${index + 1} hora${index === 0 ? "" : "s"}`}
                      >
                        {`${index + 1} hora${index === 0 ? "" : "s"}`}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Data de Início */}
                <div className="col-span-1">
                  <label className="block text-lg font-medium text-gray-700 mb-2">
                    Data de Início
                  </label>
                  <input
                    type="date"
                    value={dtinicio}
                    onChange={(e) => setDtinicio(e.target.value)}
                    className="w-full p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                {/* Data de Fim */}
                <div className="col-span-1">
                  <label className="block text-lg font-medium text-gray-700 mb-2">
                    Data de Fim
                  </label>
                  <input
                    type="date"
                    value={dtfim}
                    onChange={(e) => setDtfim(e.target.value)}
                    className="w-full p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                {/* % Coparticipação */}
                <div className="col-span-1">
                  <label className="block text-lg font-medium text-gray-700 mb-2">
                    % Coparticipação
                  </label>
                  <select
                    value={coparticipacao}
                    onChange={(e) => setCoparticipacao(e.target.value)}
                    className="w-full p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  >
                    <option value="">Selecione a coparticipação</option>
                    <option value="Demanda Judicial">Demanda Judicial</option>
                    <option value="Sem Coparticipação">
                      Sem Coparticipação
                    </option>
                    <option value="Reciprocidade">Reciprocidade</option>
                    <option value="Liberação Administrativa">
                      Liberação Administrativa
                    </option>
                  </select>
                </div>

                {/* Materiais Fornecidos */}
                <div className="col-span-1">
                  <label className="block text-lg font-medium text-gray-700 mb-2">
                    Materiais Fornecidos
                  </label>
                  <select
                    value={materiaisFornecidos}
                    onChange={(e) => setMateriaisFornecidos(e.target.value)}
                    className="w-full p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  >
                    <option value="">Selecione a letra</option>
                    {letras.map((letra) => (
                      <option key={letra} value={letra}>
                        {letra}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Empresa Responsável */}
                <div className="col-span-1">
                  <label className="block text-lg font-medium text-gray-700 mb-2">
                    Empresa Responsável
                  </label>
                  <select
                    value={empresa}
                    onChange={(e) => setEmpresa(e.target.value)}
                    className="w-full p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Selecione a empresa</option>
                    <option value="Milagres">Milagres</option>
                  </select>
                </div>

                {profissionaisList.map((item, index) => (
                  <div key={index} className="mb-6">
                    {/* Profissionais */}
                    <div>
                      <label className="block text-lg font-medium text-gray-700 mb-2">
                        Profissionais
                      </label>
                      <select
                        value={item.profissional}
                        onChange={(e) =>
                          handleChangeProfissional(
                            index,
                            "profissional",
                            e.target.value
                          )
                        }
                        className="w-full p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                      >
                        <option value="">Selecione o profissional</option>
                        <option value="Fisio">Fisio</option>
                        <option value="Fono">Fono</option>
                        <option value="Psico">Psico</option>
                        <option value="Nutri">Nutri</option>
                        <option value="Curativo">Curativo</option>
                      </select>
                    </div>

                    {/* Exibir Quantidade de Sessões e Período */}
                    {item.profissional && (
                      <div>
                        <label className="block text-lg font-medium text-gray-700 mb-2 mt-3">
                          Quantidade de sessões
                        </label>
                        <div className="flex space-x-2">
                          <input
                            type="text"
                            value={item.quantidade}
                            onChange={(e) =>
                              handleChangeProfissional(
                                index,
                                "quantidade",
                                e.target.value
                              )
                            }
                            placeholder="Ex: MOT/RESP – 3X"
                            className="w-full p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                          />
                          <select
                            value={item.periodo}
                            onChange={(e) =>
                              handleChangeProfissional(
                                index,
                                "periodo",
                                e.target.value
                              )
                            }
                            required
                            className="w-auto p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          >
                            <option value="">Selecione um periodo</option>
                            <option value="dia">dia</option>

                            <option value="semana">Semana</option>
                            <option value="mes">Mês</option>
                          </select>
                        </div>

                        {/* Botão de Adicionar Profissional */}
                        {item.profissional && item.quantidade && (
                          <div className="flex space-x-2 mt-4">
                            {/* Botão de Adicionar Profissional */}
                            <button
                              type="button"
                              onClick={handleAddProfissional}
                              className="w-8 flex justify-center items-center p-2 bg-blue-500 text-white rounded-lg"
                            >
                              <FaPlus className="mr-1 ml-1" />
                            </button>

                            {/* Botão de Remover Profissional */}
                            <button
                              type="button"
                              onClick={() => handleRemoveProfissional(index)}
                              className="p-2 bg-red-500 text-white rounded-lg flex justify-center items-center"
                            >
                              <FaMinus className="mr-1 ml-1" />
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))}

                {/* Cidade */}
                <div className="col-span-1 mb-4">
                  <label className="block text-lg font-medium text-gray-700 mb-2">
                    Cidade
                  </label>
                  <select
                    value={cidade}
                    onChange={handleCidadeChange}
                    className="w-full p-3 border rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">Selecione a cidade</option>
                    {cidades.map((cidade, index) => (
                      <option key={index} value={cidade}>
                        {cidade}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex justify-end space-x-4 mt-1">
                  <button
                    type="button"
                    onClick={fecharModal}
                    className="bg-gray-700 text-white px-6 py-2 rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-600"
                  >
                    Cancelar
                  </button>

                  <button
                    type="submit"
                    className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-700"
                  >
                    {nome ? "Salvar Alterações" : "Adicionar Paciente"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Lista de Pacientes */}
      <div className="mt-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Lista de Pacientes
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {pacientes.map((paciente, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 space-y-4"
            >
              <h3 className="text-xl font-semibold text-gray-800">
                {paciente.nome}
              </h3>
              <p>
                <strong>Regime de Home:</strong> {paciente.regimeDeHome}
              </p>
              <p>
                <strong>Coparticipação:</strong> {paciente.coparticipacao}
              </p>
              <p>
                <strong>Profissionais:</strong>
                {/* Aqui iteramos sobre o array de profissionais */}
                <ul>
                  {paciente.profissionais.map((profissional, index) => (
                    <li key={index}>
                      Profissional: {profissional.profissional}, Quantidade:{" "}
                      {profissional.quantidade}, Período: {profissional.periodo}
                    </li>
                  ))}
                </ul>{" "}
              </p>
              <p>
                <strong>Materiais Fornecidos:</strong>{" "}
                {paciente.materiaisFornecidos}
              </p>
              <p>
                <strong>Empresa:</strong> {paciente.empresa}
              </p>

              <p>
                <strong>Cidade:</strong> {paciente.cidade}
              </p>

              <p>
                <strong>Data inicio:</strong> {paciente.dtinicio}
              </p>

              <p>
                <strong>Data final:</strong> {paciente.dtfim}
              </p>

              <div className="flex justify-between">
                <button
                  onClick={() => editarPaciente(paciente)}
                  className="bg-yellow-400 text-white px-4 py-2 rounded-md hover:bg-yellow-500"
                >
                  Editar
                </button>
                <button
                  onClick={() => excluirPaciente(index)}
                  className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700"
                >
                  Excluir
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default App;
